/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ref_N3Inputs */

const en_csv_to_json_ref_n3 = /** @type {(inputs: Csv_To_Json_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A newline inside quotes stays in the value rather than ending the record.`)
};

const ko_csv_to_json_ref_n3 = /** @type {(inputs: Csv_To_Json_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인용부호 안의 줄바꿈은 레코드를 끝내지 않고 값에 남습니다.`)
};

const ja_csv_to_json_ref_n3 = /** @type {(inputs: Csv_To_Json_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用符内の改行はレコードを終わらせず値に残ります。`)
};

/**
* | output |
* | --- |
* | "A newline inside quotes stays in the value rather than ending the record." |
*
* @param {Csv_To_Json_Ref_N3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ref_n3 = /** @type {((inputs?: Csv_To_Json_Ref_N3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ref_N3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ref_n3(inputs)
	if (locale === "ko") return ko_csv_to_json_ref_n3(inputs)
	return ja_csv_to_json_ref_n3(inputs)
});